import type React from 'react'
import type { Dispatch, SetStateAction } from 'react'

import { Icon, Modal } from 'components'
import { useSelector } from 'store/store'
import { theme } from 'styles/theme/hav-theme'

import { OverviewValue } from './components'
import * as S from './styles'

interface OrderOverviewModalProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
  loadingConfirm?: boolean
  onReturn?: () => void
  disabled?: boolean
}

const OrderOverviewModal: React.FC<OrderOverviewModalProps> = ({
  open,
  setOpen,
  onConfirm,
  loadingConfirm,
  onReturn = () => setOpen(false),
  disabled = false,
}) => {
  const { simulateOrder, isSampleOrder } = useSelector((state) => state.salesOrder)
  const qt_ov_gera = simulateOrder?.resumo.vl_tota_orde_gera

  return (
    <Modal
      buttonAction={onConfirm}
      buttonDisabled={disabled}
      buttonText="Confirmar"
      description={
        <>
          Confira abaixo a simulação da distribuição dos materiais do pedido{' '}
          <strong>#{simulateOrder?.nr_pedi_rasc}</strong>
        </>
      }
      descriptionSize={14}
      loading={loadingConfirm}
      modalWidth={456}
      open={open}
      returnAction={onReturn}
      returnIcon={''}
      returnText="Voltar"
      setOpen={setOpen}
      showReturn
      title="Resumo"
      titleSize={22}
    >
      <S.OverviewValues>
        <OverviewValue
          icon={<Icon color={theme.colors.neutral[60]} icon="pencil" size="16" />}
          iconColorBackground={theme.colors.neutral.softer}
          subtitle={`${simulateOrder?.resumo.qt_item_aber_resu_conv} pares`}
          title="Em aberto"
          tooltip="Materiais que não geraram OVs durante a transação."
          value={simulateOrder?.resumo.vl_item_aber_resu ?? 0}
        />
        <OverviewValue
          icon={<Icon color={theme.colors.alert.warning.dark} icon="report" size="16" />}
          iconColorBackground={theme.colors.alert.warning[10]}
          subtitle={`${simulateOrder?.resumo.qt_item_anls_resu_conv} pares`}
          title="Em análise"
          tooltip="Materiais sem disponibilidade de cota e/ou estoque, mas com solicitação de volume extra."
          value={simulateOrder?.resumo.vl_item_anls_resu ?? 0}
          visible={!isSampleOrder}
        />
        <OverviewValue
          icon={<Icon color={theme.colors.alert.success.dark} icon="circle-check" size="16" />}
          iconColorBackground={theme.colors.alert.success[10]}
          subtitle={`${simulateOrder?.resumo.qt_item_conv_orde} pares -> ${qt_ov_gera} ${
            qt_ov_gera && qt_ov_gera > 1 ? 'ovs' : 'ov'
          }`}
          title="OVs geradas"
          tooltip="Materiais que atendem aos requisitos de cota, estoque e/ou valor mínimo, que estão aptos para gerar OVs e serem enviados ao SAP. Os valores apresentados são simulações; confirme a solicitação para garantir a sua disponibilidade."
          value={simulateOrder?.resumo.vl_item_orde ?? 0}
        />
      </S.OverviewValues>

      <S.ObservationText>
        Ao clicar em confirmar, as OVs geradas serão{' '}
        <strong>enviadas automaticamente ao SAP.</strong>
        Materiais em aberto ou em análise <strong>não possuem garantia de disponibilidade.</strong>
      </S.ObservationText>
    </Modal>
  )
}

export default OrderOverviewModal
